import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import './GestaoCadastrosPage.css';

const GestaoCadastrosPage = () => {
  return (
    <>
      <Header />
      
      <div className="gestao-container">
        <div className="gestao-content">
          <div className="gestao-left">
            <div className="gestao-logo">
              <img src="/logo/Logo_Sem_Fundo.png" alt="Veridicus Logo" className="logo-img" />
              <h1 className="overlay-title">GESTÃO DE CADASTROS FISCAIS E SOCIETÁRIOS</h1>
            </div>
          </div>
          
          <div className="gestao-right">
            <div className="gestao-description">
              <p className="gestao-intro">
                Centralize e acompanhe todos os cadastros da empresa com precisão:
              </p>
              
              <ul className="gestao-services">
                <li>Abertura e alteração de CNPJ;</li>
                <li>Inscrições estaduais e municipais;</li>
                <li>Cadastros em órgãos de classe e conselhos profissionais;</li>
                <li>Atualização de dados cadastrais;</li>
                <li>Regularização de pendências;</li>
                <li>Emissão de certidões negativas de débitos.</li>
              </ul>
              
              <p>
                Cada cadastro é monitorado e atualizado automaticamente, garantindo que informações estejam corretas e acessíveis. 
                A plataforma identifica inconsistências e alerta sobre pendências, permitindo correções rápidas. Certidões negativas e 
                relatórios detalhados ficam disponíveis para consulta, oferecendo controle completo e segurança para sua equipe agir 
                com confiança.
              </p>
            </div>
            
            <div className="gestao-cta">
              <Link to="/fale-conosco" className="cta-button">
                Entre em contato
              </Link>
            </div>
          </div>
        </div>
        
        <div className="gestao-navigation">
          <Link to="/servicos/presenca-estrategica" className="nav-prev">
            ← PRESENÇA ESTRATÉGIA EM ÓRGÃOS E CONSELHOS
          </Link>
          <Link to="/servicos/alvaras" className="nav-next">
            EMISSÃO DE ALVARÁS E AUTORIZAÇÕES →
          </Link>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default GestaoCadastrosPage;